import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DateService {

  constructor() {}

  public getDateFormatted(dateString: string): string {
    const date = new Date(dateString);
    const month = date.toLocaleString('en-US', { month: 'long', timeZone: 'UTC' }).toUpperCase();
    const day = date.getUTCDate().toString().padStart(2, '0');
    const year = date.getUTCFullYear().toString();
    const getDateFormatted = `${month} ${day}, ${year}`;

    return getDateFormatted;
  }
}
